var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._b({attrs:{"type":_vm.type,"native-type":"button","loading":_vm.loading},on:{"click":_vm.handleClick}},'a-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }